import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, CircularProgress, Divider, IconButton } from '@mui/material';
import { Formik, Form, FieldArray } from "formik";
import * as Yup from 'yup';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import CustomButton from "../../../components/common/CustomButton";
import CustomTextField from "../../../components/common/CustomTextField";
import CustomTextarea from "../../../components/common/CustomTextarea";
import { genericPost } from '../../../services/authServices';
import { BLOG_CREATE, CASE_STUDY_CREATE, } from '../../../services/apiRoutes';
import { t } from "../../../constants/translationHelper";
import CustomAutocomplete from "../../../components/common/CustomAutoComplete";
import axios from "axios";

import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import draftToHtml from 'draftjs-to-html';
import { EditorState, convertFromHTML, ContentState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { AddCircle, Delete } from "@mui/icons-material";



const ValidationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    featuredImage: Yup.mixed().required('Featured Image is required'),
    category: Yup.string().required('Category is required'),
    metaTitle: Yup.string().required('Meta Title is required'),
    metaDescription: Yup.string().required('Meta Description is required'),
    views: Yup.number().required('Views is required'),
    publishedAt: Yup.date().required('Published Date is required'),
    status: Yup.string().required('Status is required'),
    particulars: Yup.array().of(
        Yup.object().shape({
            sectionHeading: Yup.string().required("Heading required"),
            sectionContent: Yup.string().required("Content required"),
            sectionImage: Yup.mixed().required("Section Image is required"),
        })
    ).min(1, "At least one section required"),
});


const CreateCaseStudy = ({ handleClose, setMessage, fetchData, blogCategory, blogStatus }) => {

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [sectionEditors, setSectionEditors] = useState([
        EditorState.createEmpty()
    ]);

    const onEditorStateChange = (state) => {
        setEditorState(state);
    };

    const handleSectionEditorChange = (index, state, setFieldValue) => {
        const updatedEditors = [...sectionEditors];
        updatedEditors[index] = state;
        setSectionEditors(updatedEditors);

        // ✅ Convert to HTML & store in Formik
        const html = draftToHtml(convertToRaw(state.getCurrentContent()));

        setFieldValue(`particulars.${index}.sectionContent`, html);
    };
    const convertToHTMLContent = () => {
        const contentState = editorState.getCurrentContent();
        const htmlContent = draftToHtml(convertToRaw(contentState));

        return htmlContent;
    };

    // ✅ Image handler
    const handleImageChange = (event, setFieldValue) => {
        const file = event.target.files[0];
        if (file) {
            setFieldValue("featuredImage", file);
        }
    };

    const handleSectionImageChange = (event, index, setFieldValue) => {
        const file = event.target.files[0];
        if (file) {
            setFieldValue(`particulars.${index}.sectionImage`, file);
        }
    };
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const htmlContent = convertToHTMLContent();

            const formData = new FormData();

            // ✅ Basic Fields
            formData.append("title", values.title);
            formData.append("content", htmlContent || "");
            formData.append("category", values.category);
            formData.append("status", values.status);

            // ✅ SEO Fields
            formData.append("metaTitle", values.metaTitle);
            formData.append("metaDescription", values.metaDescription);
            formData.append("views", values.views || 0);
            formData.append("publishedAt", values.publishedAt);

            // ✅ Featured Image (FILE)
            if (values.featuredImage) {
                formData.append("featuredImage", values.featuredImage);
            }

            // ✅ IMPORTANT: MULTIPLE PARTICULARS
            values.particulars.forEach((item, index) => {
                formData.append(`particulars[${index}][sectionHeading]`, item.sectionHeading);
                formData.append(`particulars[${index}][sectionContent]`, item.sectionContent);
                if (item.sectionImage) {
                    formData.append(`particulars[${index}][sectionImage]`, item.sectionImage);
                }




            });

            const token = sessionStorage.getItem("accessToken");

            const response = await axios.post(CASE_STUDY_CREATE, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: "Case Study Created Successfully",
                    type: "success",
                });

                setTimeout(() => {
                    fetchData();
                    handleClose();
                }, 1000);
            }

        } catch (error) {
            console.error(error);
            setMessage({
                open: true,
                text: "Error creating case study",
                type: "error",
            });
        } finally {
            setSubmitting(false);
        }
    };
    const [formData] = useState({
        title: '',
        content: '',
        featuredImage: '',
        category: '',
        metaTitle: '',
        metaDescription: '',
        views: 0,
        publishedAt: '',
        status: '',
        particulars: [
            {
                sectionHeading: "",
                sectionImage: null,
                sectionContent: "",
            },
        ],


    });

    return (
        <Box sx={{ mx: 'auto', mt: 0 }}>
            <Formik
                initialValues={formData}
                validationSchema={ValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                    <Form>
                        <Grid
                            container
                            spacing={1}
                            style={{ position: "sticky" }}
                        >
                            <Grid item xs={4} md={4}>
                                <Typography sx={{ fontWeight: 600 }} style={{ color: "#212529", fontSize: "18px", paddingTop: "5px" }}>
                                    {t("Add Case Study")}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={8}
                                md={8}
                                style={{ display: "flex", justifyContent: "flex-end" }}
                            >
                                <Box style={{ display: "flex" }}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={2} sx={{ px: "5%", paddingTop: "5px" }}>

                            <Grid item xs={12} md={6}>
                                <CustomTextarea
                                    placeholder="Enter title"
                                    name="title"
                                    fieldLabel="Title"
                                    required
                                    value={values.title}
                                    onChange={handleChange}
                                    error={touched.title && !!errors.title}
                                    helperText={touched.title && errors.title}
                                />
                            </Grid>

                            {/* Category */}
                            <Grid item xs={12} md={6}>

                                <CustomAutocomplete
                                    options={blogCategory}
                                    fieldLabel="Category"
                                    required={true}
                                    getOptionLabel={(option) => option.title || ""}
                                    value={
                                        blogCategory.find((option) => option.id === values.category) || null
                                    }
                                    onChange={(e, newValue) =>
                                        setFieldValue("category", newValue ? newValue.id : "")
                                    }
                                    placeholder="Select Category"
                                    error={touched.category && !!errors.category}
                                    helperText={touched.category && errors.category}
                                />
                            </Grid>

                            {/* Meta Title */}
                            <Grid item xs={12} md={6}>
                                <CustomTextarea
                                    placeholder="Enter meta title"
                                    name="metaTitle"
                                    fieldLabel="Meta Title"
                                    required
                                    value={values.metaTitle}
                                    onChange={handleChange}
                                    error={touched.metaTitle && !!errors.metaTitle}
                                    helperText={touched.metaTitle && errors.metaTitle}
                                />
                            </Grid>

                            {/* Featured Image */}
                            <Grid item xs={12} md={6}>
                                <Typography variant="subtitle2">Featured Image *</Typography>

                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleImageChange(e, setFieldValue)}
                                />

                                {touched.featuredImage && errors.featuredImage && (
                                    <Typography variant="caption" color="error">
                                        {errors.featuredImage}
                                    </Typography>
                                )}
                            </Grid>




                            {/* Meta Description */}
                            <Grid item xs={12}>
                                <CustomTextarea
                                    placeholder="Enter meta description"
                                    name="metaDescription"
                                    fieldLabel="Meta Description"
                                    required
                                    value={values.metaDescription}
                                    onChange={handleChange}
                                    error={touched.metaDescription && !!errors.metaDescription}
                                    helperText={touched.metaDescription && errors.metaDescription}
                                />
                            </Grid>

                            {/* Views */}
                            <Grid item xs={12} md={4}>
                                <CustomTextField
                                    type="number"
                                    placeholder="Enter views"
                                    name="views"
                                    fieldLabel="Views"
                                    required
                                    value={values.views}
                                    onChange={handleChange}
                                    error={touched.views && !!errors.views}
                                    helperText={touched.views && errors.views}
                                />
                            </Grid>

                            {/* Published Date */}
                            <Grid item xs={12} md={4}>
                                <CustomTextField
                                    type="date"
                                    name="publishedAt"
                                    fieldLabel="Published Date"
                                    required
                                    value={values.publishedAt}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    error={touched.publishedAt && !!errors.publishedAt}
                                    helperText={touched.publishedAt && errors.publishedAt}
                                />
                            </Grid>

                            {/* Status */}
                            <Grid item xs={12} md={4}>
                                <CustomAutocomplete
                                    options={blogStatus}
                                    fieldLabel="Status"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={blogStatus.find((option) => option.id === values.status) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('status', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select status"
                                    error={touched.status && !!errors.status}
                                    helperText={touched.status && errors.status}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    wrapperStyle={{
                                        border: '1px solid #CED4DA', borderRadius: '4px',
                                    }}
                                    editorStyle={{ padding: "10px" }}
                                    toolbar={{
                                        options: [
                                            'inline',
                                            'blockType',
                                            'fontSize',
                                            'fontFamily',
                                            'list',
                                            'textAlign',
                                            'colorPicker',
                                            'link',
                                            'emoji',
                                            'remove',
                                            'history'
                                        ],
                                        inline: {
                                            inDropdown: false,
                                            options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                                        },
                                        blockType: {
                                            inDropdown: true,
                                            options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                                        },
                                        fontSize: {
                                            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                                        },
                                        list: {
                                            inDropdown: false,
                                            options: ['unordered', 'ordered', 'indent', 'outdent'],
                                        },
                                        textAlign: {
                                            inDropdown: false,
                                            options: ['left', 'center', 'right', 'justify'],
                                        },
                                        link: {
                                            inDropdown: false,
                                            options: ['link', 'unlink'],
                                        },
                                        history: {
                                            inDropdown: false,
                                            options: ['undo', 'redo'],
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <FieldArray name="particulars">
                            {({ push, remove }) => (
                                <>
                                    <Box
                                        mt={4}
                                        mb={3}
                                        sx={{
                                            p: 2,
                                            borderRadius: "12px",
                                            background: "linear-gradient(90deg,#f8f9fa,#eef3ff)",
                                            border: "1px solid #dce3f0",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: "18px",
                                                color: "#343A40"
                                            }}
                                        >
                                            Section Details
                                        </Typography>

                                        <CustomButton
                                            startIcon={<AddCircle />}
                                            title="Add Section"
                                            size="small"
                                            variant="contained"
                                            onClick={() => {
                                                push({
                                                    sectionHeading: "",
                                                    sectionImage: null,
                                                    sectionContent: "",
                                                });

                                                setSectionEditors(prev => [
                                                    ...prev,
                                                    EditorState.createEmpty()
                                                ]);
                                            }}
                                        />

                                    </Box>

                                    {values.particulars.map((item, index) => (
                                        <Box
                                            key={index}
                                            mt={3}
                                            sx={{
                                                p: 3,
                                                borderRadius: "14px",
                                                backgroundColor: "#ffffff",
                                                border: "1px solid #E3E8EF",
                                                boxShadow: "0 4px 15px rgba(0,0,0,0.08)"
                                            }}
                                        >
                                            {/* Section Header */}
                                            <Box
                                                mb={3}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    borderBottom: "1px solid #f0f0f0",
                                                    pb: 1
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: 700,
                                                        fontSize: "16px",
                                                        color: "#1976d2"
                                                    }}
                                                >
                                                    Section #{index + 1}
                                                </Typography>

                                                <IconButton
                                                    color="error"
                                                    sx={{
                                                        background: "#fff1f0",
                                                        "&:hover": {
                                                            background: "#ffe3e0"
                                                        }
                                                    }}
                                                    onClick={() => {
                                                        remove(index);

                                                        const updatedEditors = [...sectionEditors];
                                                        updatedEditors.splice(index, 1);
                                                        setSectionEditors(updatedEditors);
                                                    }}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </Box>

                                            <Grid container spacing={3}>

                                                {/* Heading */}
                                                <Grid item xs={12} md={6}>
                                                    <CustomTextarea
                                                        name={`particulars.${index}.sectionHeading`}
                                                        placeholder="Enter section heading"
                                                        fieldLabel="Section Heading"
                                                        required
                                                        value={item.sectionHeading}
                                                        onChange={(e) =>
                                                            setFieldValue(
                                                                `particulars.${index}.sectionHeading`,
                                                                e.target.value
                                                            )
                                                        }
                                                        error={touched.sectionHeading && !!errors.sectionHeading}
                                                        helperText={touched.sectionHeading && errors.sectionHeading}
                                                    />
                                                </Grid>

                                                {/* Image */}
                                                <Grid item xs={12} md={6}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: "13px",
                                                            mb: 1
                                                        }}
                                                    >
                                                        Section Image *
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 2
                                                        }}
                                                    >
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) =>
                                                                handleSectionImageChange(
                                                                    e,
                                                                    index,
                                                                    setFieldValue
                                                                )
                                                            }
                                                            style={{
                                                                border: "1px solid #CED4DA",
                                                                padding: "8px",
                                                                borderRadius: "6px",
                                                                width: "220px",
                                                                background: "#fafafa"
                                                            }}
                                                        />

                                                        {typeof item.sectionImage === "string" && (
                                                            <img
                                                                src={item.sectionImage}
                                                                alt=""
                                                                style={{
                                                                    width: "85px",
                                                                    height: "65px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "8px",
                                                                    border: "1px solid #ddd"
                                                                }}
                                                            />
                                                        )}
                                                    </Box>

                                                    {touched?.particulars?.[index]?.sectionImage &&
                                                        errors?.particulars?.[index]?.sectionImage && (
                                                            <Typography
                                                                variant="caption"
                                                                color="error"
                                                            >
                                                                {errors.particulars[index].sectionImage}
                                                            </Typography>
                                                        )}
                                                </Grid>



                                                {/* Editor */}
                                                <Grid item xs={12} md={12}>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: "13px",
                                                            mb: 1
                                                        }}
                                                    >
                                                        Section Content *
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            border: "1px solid #CED4DA",
                                                            borderRadius: "8px",
                                                            overflow: "hidden",
                                                            background: "#fff"
                                                        }}
                                                    >

                                                        <Editor
                                                            editorState={
                                                                sectionEditors[index] ||
                                                                EditorState.createEmpty()
                                                            }
                                                            onEditorStateChange={(state) =>
                                                                handleSectionEditorChange(
                                                                    index,
                                                                    state,
                                                                    setFieldValue
                                                                )
                                                            }
                                                            wrapperClassName="demo-wrapper"
                                                            editorClassName="demo-editor"
                                                            wrapperStyle={{
                                                                border: '1px solid #CED4DA', borderRadius: '4px',
                                                            }}
                                                            editorStyle={{ padding: "10px" }}
                                                            toolbar={{
                                                                options: [
                                                                    'inline',
                                                                    'blockType',
                                                                    'fontSize',
                                                                    'fontFamily',
                                                                    'list',
                                                                    'textAlign',
                                                                    'colorPicker',
                                                                    'link',
                                                                    'emoji',
                                                                    'remove',
                                                                    'history'
                                                                ],
                                                                inline: {
                                                                    inDropdown: false,
                                                                    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                                                                },
                                                                blockType: {
                                                                    inDropdown: true,
                                                                    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                                                                },
                                                                fontSize: {
                                                                    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                                                                },
                                                                list: {
                                                                    inDropdown: false,
                                                                    options: ['unordered', 'ordered', 'indent', 'outdent'],
                                                                },
                                                                textAlign: {
                                                                    inDropdown: false,
                                                                    options: ['left', 'center', 'right', 'justify'],
                                                                },
                                                                link: {
                                                                    inDropdown: false,
                                                                    options: ['link', 'unlink'],
                                                                },
                                                                history: {
                                                                    inDropdown: false,
                                                                    options: ['undo', 'redo'],
                                                                },
                                                            }}
                                                        />



                                                    </Box>

                                                    {touched?.particulars?.[index]?.sectionContent &&
                                                        errors?.particulars?.[index]?.sectionContent && (
                                                            <Typography
                                                                variant="caption"
                                                                color="error"
                                                            >
                                                                {errors.particulars[index].sectionContent}
                                                            </Typography>
                                                        )}
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))}
                                </>
                            )}
                        </FieldArray>


                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default CreateCaseStudy;
